import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlagsService } from '../shared-service/feature-flags.service';

@Directive({
  selector: '[lfFeatureOff]'
})
export class FeatureOffFlagsDirective implements OnInit {

  @Input() lfFeatureOff: string | string[];
  constructor(
    private vcr: ViewContainerRef,
    private tpl: TemplateRef<any>,
    private featureService: FeatureFlagsService
  ) { }

  async ngOnInit() {
    await this.featureService.initialize();
    if(!this.featureService.isOn(this.lfFeatureOff)) {
      this.vcr.createEmbeddedView(this.tpl);
    }
  }
}
